$(document).ready(function() {
    var consentIsSet = "unknown";
    var cookieBanner = "#cookieBanner";
    var consentString = "cookieConsent=";

    // Sets a cookie granting/denying consent, and displays some text on console/banner
    function setCookie(console_log, banner_text, consent) {
        console.log(console_log);
        $(cookieBanner).text(banner_text);
        $(cookieBanner).fadeOut(2000);
        var d = new Date();
        var exdays = 30*12; //  1 year
        d.setTime(d.getTime()+(exdays*24*60*60*1000));
        var expires = "expires="+d.toGMTString();
        document.cookie = consentString + consent + "; " + expires + ";path=/";
        consentIsSet = consent;
    }

    function denyConsent() {
        setCookie("Consent denied", _trans('Non hai accetatto le cookies potresti avere problemi di navigazione.', Lang.get('messaggi.navigation_problems')), "false");
        // Unbind consent-granting actions
        $(window).unbind("scroll");
        $("a:not(.noconsent)").unbind("click");
    }

    function grantConsent() {
        if (consentIsSet == "true") return; // Don't grant twice
        setCookie("Consent granted", _trans('Grazie per accettare le cookies di sistema.',Lang.get('messaggi.accepting_cookies')), "true");
    }

    // Run the consent code. We may be called either from grantConsent() or 
    // from the main routine


    // main routine
    //
    // First, check if cookie is present
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var c = cookies[i].trim();
        if (c.indexOf(consentString) == 0) {
            consentIsSet = c.substring(consentString.length, c.length);
        }
    }

    if (consentIsSet == "unknown") {
        $(cookieBanner).fadeIn();
        // The two cases where consent is granted: scrolling the window or clicking a link
        // Don't set cookies on the "cookies page" on scroll
        var pageName = location.pathname.substr(location.pathname.lastIndexOf("/") + 1);

        $("a:not(.noconsent)").click(grantConsent);
        $(".denyConsent").click(denyConsent);
        document.addEventListener('scroll', function (event) {
            if (consentIsSet === 'unknown') { // apply any filtering condition
                grantConsent()
            }
            console.log('sd')
        }, true /*Capture event*/);
        // allow re-enabling cookies
        $(".allowConsent").click(grantConsent);
    }
});